export const BASE_CLASS = 'mt-UserAlerts'
